<template>
  <PrintPage :pageNumber="pageNumber">
    <template v-slot:header>
      <slot>
        <PrintHeaderSSPSlim />
      </slot>
    </template>

    <AttachmentsPrintGrid
      :attachments="project.clampAreaAttachments"
      fieldName="clampAreaAttachments"
      :maxImages="2"
    />

    <AttachmentsPrintGrid
      :attachments="project.trayfDistanceAttachments"
      fieldName="trayfDistanceAttachments"
      :maxImages="2"
    />

    <div class="content-box">
      <div class="two-column-grid">
        <div>{{ $t('solarPanelE1State') }}</div>
        <div>{{ $t(project.enpalReport.solarPanelE1State) }}</div>
      </div>
    </div>

    <AttachmentsPrintGrid
      :attachments="project.railOverlapAttachments"
      fieldName="railOverlapAttachments"
      :maxImages="2"
    />
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderSSPSlim from '@/components/Print/PrintHeaderSSPSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';
import { range } from '@/helpers/math.js';

export default {
  name: 'MeasurementPrintPage1',
  components: {
    PrintPage,
    PrintHeaderSSPSlim,
    AttachmentsPrintGrid,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {},
  methods: { range },
};
</script>
